import { useRef } from "react";

const debounce = <T extends (...args: Parameters<T>) => void>(func: T, wait: number): T => {
  let timeoutId: NodeJS.Timeout | null = null;

  return ((...args: Parameters<T>) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      func(...args);
    }, wait);
  }) as T;
};

export const useDebounce = <T extends (...args: Parameters<T>) => void>(func: T, wait: number) => {
  const debouncedFuncRef = useRef(debounce(func, wait));

  return debouncedFuncRef.current;
};
